"use server";

import { cookies, headers } from "next/headers";
import { redirect } from "next/navigation";
import { resolvePostLoginPath } from "@/lib/auth/app-home.mjs";

function isHttpsRequest(h: Headers) {
  const forwarded = h.get("x-forwarded-proto");
  if (forwarded) return forwarded.split(",")[0].trim() === "https";
  return false;
}

/**
 * Server Action login — lands on Company Twin (new UI).
 */
export async function loginAction(formData: FormData) {
  const email = String(formData.get("email") ?? "").trim();
  const password = String(formData.get("password") ?? "");
  const next = resolvePostLoginPath(String(formData.get("next") ?? ""));

  if (!email || !password) {
    const q = new URLSearchParams({
      error: "Bitte E-Mail und Passwort eingeben",
      email,
      failed: "1",
      next,
    });
    redirect(`/login?${q}`);
  }

  const { verifyEmployeeLogin } = await import("@/lib/auth/employees.mjs");
  const result = await verifyEmployeeLogin("", email, password);

  if (result.error === "invalid_credentials") {
    const q = new URLSearchParams({
      error: "E-Mail oder Passwort ungültig",
      email,
      failed: "1",
      next,
    });
    redirect(`/login?${q}`);
  }
  if (result.error === "email_not_verified") {
    const q = new URLSearchParams({
      error: "Bitte zuerst E-Mail bestätigen",
      email,
      failed: "1",
      next,
    });
    redirect(`/login?${q}`);
  }

  const h = await headers();
  const { createSessionToken } = await import("@/lib/auth/session.mjs");
  const { applySessionCookie } = await import("@/lib/auth/apply-session-cookie.mjs");
  const token = await createSessionToken({
    id: result.employee.id,
    email: result.employee.email,
    name: result.employee.name,
    department: result.employee.department,
    companyId: result.companyId,
  });

  const jar = await cookies();
  applySessionCookie(jar, token, { secure: isHttpsRequest(h) });

  redirect(next);
}
